<template>
    <DModal
        :show="showModal"
        :title="__('orders.check.automatic_checks_tab.find_customer')"
        overflow-auto
        is-confirm
        :is-awaiting-validation="true"
        @close="$emit('close')"
        @confirm="confirm"
    >
        <DCard padding>
            <DRow>
                <DCol sm="8">
                    <DFormRow
                        :label="__('orders.check.automatic_checks_tab.customer_id')"
                        :is-required="true"
                        :error="errorsData[0]"
                    >
                        <DInput
                            id="customer_id"
                            v-model="searchCustomerId"
                            add-label-classes="required"
                            min="0"
                            max="255"
                        />
                    </DFormRow>
                </DCol>
                <DCol
                    sm="4"
                    class="text-end"
                >
                    <DButton
                        id="find-customer"
                        icon="magnify"
                        :label="__('orders.check.automatic_checks_tab.search')"
                        @click="findCustomer(searchCustomerId)"
                    />
                </DCol>
            </DRow>
            <DRow v-if="customer !== null">
                <DCol sm="8">
                    <DFormRow
                        :label="__('orders.check.automatic_checks_tab.customer')"
                    >
                        <span v-if="customer.firstname">{{ customer.firstname }}</span>
                        <span v-if="customer.lastname">{{ customer.lastname }}</span>
                        <span v-if="customer.company">{{ customer.company }}</span>
                    </DFormRow>
                </DCol>
            </DRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { ref } from 'vue'

import { route } from '~@/Composables/route'

defineProps({
    showModal: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close', 'confirm'])

const searchCustomerId = ref(null)
const errorsData = ref([])
const customer = ref(null)

function findCustomer (id) {
    errorsData.value = []
    customer.value = null

    window.axios.get(route('orders.psa.find_customer', {
        customerId: id
    }))
        .then((response) => {
            customer.value = response.data.customer
        })
        .catch((error) => {
            if (error && error.response && error.response.data.errors !== undefined) {
                const errorObject = error.response.data.errors

                Object.keys(errorObject).forEach((field) => {
                    errorObject[field].forEach((message) => {
                        errorsData.value.push(message)
                    })
                })
            }
        })
}

function confirm () {
    emit('confirm', customer.value)
}

</script>

<style scoped lang="scss">

</style>
